const resource = {
  HELPER_SECTION: {
    DESCRIPTIONS: [
      `Please email contact@competas.com if you require assitance.`,
    ],
  },
};

export default resource;
